export default __webpack_public_path__ + "static/island-life-desktop-414e25997f326a089a751fa8a6377597.webp";